import { Tag, TagRootPropsInterface } from '@zillow/constellation-10';
import React from 'react';

type Props = {
  linkId: string;
  text: string;
  shouldWrapText?: boolean;
};

export const STATUS_LABEL_TOUR_CANCELED = 'statusLabelTourCanceled';
export const STATUS_LABEL_TOUR_DECLINED = 'statusLabelTourDeclined';
export const STATUS_LABEL_TOUR = 'statusLabelTour';

const getTagApperanceValueByLinkId = (linkId: string): TagRootPropsInterface['tone'] => {
  switch (linkId) {
    // Critical label
    case 'statusLabelAwaitingYourSignature':
    case STATUS_LABEL_TOUR_DECLINED:
      return 'critical';

    // Gray label
    case 'statusLabelExpired':
    case 'statusLabelInvitedToApply':
    case 'statusLabelLeaseCanceled':
    case 'statusLabelPayments':
    case 'statusLabelToured':
    case 'statusLabelTourRequested':
    case 'statusLabelTourDeclined':
    case 'statusLabelApplicationWithdrawn':
    case STATUS_LABEL_TOUR_CANCELED:
      return 'gray';

    // Info label
    case 'statusLabelSigningInProgress':
    case STATUS_LABEL_TOUR:
      return 'info';

    // Warning label
    case 'statusLabelTourExpired':
    case 'statusResponseOverdue':
    case 'statusLabelApplicationConditionallyApproved':
      return 'warning';

    // Success label
    case 'statusLabelLease':
    case 'statusLabelApplicationReceived':
    case 'statusLabelApplicationApproved':
      return 'success';

    // Deprecate
    case 'statusLabelReceived':
      return 'success';
    case 'statusLabelWithdrawn':
      return 'gray';
    default:
      return 'gray';
  }
};

const StatusLabel = ({ text, linkId, shouldWrapText = true }: Props): JSX.Element => {
  const tagAppearanceOption = getTagApperanceValueByLinkId(linkId);

  return (
    <Tag
      tone={tagAppearanceOption}
      size="sm"
      css={{ verticalAlign: 'middle', ...(shouldWrapText ? { textWrap: 'wrap' } : { textWrap: 'nowrap' }) }}
    >
      {text}
    </Tag>
  );
};

export default React.memo(StatusLabel);
